@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <mat-label class="mr-2 font-medium">{{ field.label | localize }}@if (field.required) {
        <span> *</span>
      }</mat-label>
      @if (!field.control.disabled) {
        <mat-chip-listbox class="p-4" selectable="false">
          @for (col of columns; track col) {
            <mat-chip class="flex flex-row items-center" [disabled]="chipAlreadyExist(col.name)">
              <span>{{ col.name }}</span>
              <button matChipTrailingIcon [disabled]="chipAlreadyExist(col.name)" mat-icon-button (click)="add(col)">
                <mat-icon svgIcon="mat_outline:add"></mat-icon>
              </button>
            </mat-chip>
          }
        </mat-chip-listbox>
      }
      <div class="flex flex-row items-center w-full">
        <mat-form-field class="w-full">
          <mat-chip-grid #chipGrid class="p-2" [formControl]="field.control">
            @for (chip of fields; track chip; let i = $index) {
              <mat-chip-row [value]="chip"
                [selectable]="false" [selected]="false" [removable]="!field.control.disabled"
                (removed)="removeChip(chip)">
                {{ chip }}
                <button matChipRemove>
                  <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:cancel'"></mat-icon>
                </button>
              </mat-chip-row>
            }
            <input [matChipInputFor]="chipGrid" [placeholder]="field.placeholder | localize"
              [matChipInputAddOnBlur]="true" [matChipInputSeparatorKeyCodes]="separators" [readonly]="true"
              autocomplete="off"/>
            </mat-chip-grid>
            @if (field.hint) {
              <mat-hint>{{ field.hint | localize }}</mat-hint>
            }
            @if (field.control.hasError('validateArrayNotEmpty') && !field.readonly) {
              <mat-error>
                {{ 'errorRequiredField' | transloco }}
              </mat-error>
            }
            @if (field.control.hasError('minlength') && !field.readonly) {
              <mat-error>
                {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
              </mat-error>
            }
            @if (field.control.hasError('maxlength') && !field.readonly) {
              <mat-error>
                {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }
  } @else {
    {{ field.control.value }}
  }

